// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RzE-","toggle":"styles_toggle__Jnr7C","preview":"styles_preview__1KezE"};